import { Card, Col, Row } from 'antd';
import {
  CalendarOutlined, IdcardOutlined, ScheduleOutlined, TeamOutlined,
} from '@ant-design/icons';
import { Link } from 'react-router';
import type { DashboardSummary } from '@/api/dashboard';
import {
  DashboardHeader, KpiGrid, RecentNoticesCard, type KpiSpec,
} from './shared';

/**
 * HR Manager dashboard — staff focus. No fees, no academics, no front desk.
 */
export function HrDashboard({ data }: { data: DashboardSummary }) {
  const staffPresent = data.staffAttendanceToday.present;
  const staffTotal = data.staffAttendanceToday.expected;
  const staffPct = staffTotal === 0 ? 0 : Math.round((staffPresent / staffTotal) * 1000) / 10;

  const kpis: KpiSpec[] = [
    {
      key: 'active-staff',
      label: 'Active staff',
      value: data.staff.active.toLocaleString(),
      hint: `${data.staff.total.toLocaleString()} total`,
      icon: <TeamOutlined />,
      tone: 'primary',
    },
    {
      key: 'staff-today',
      label: "Staff present today",
      value: staffTotal === 0 ? '—' : `${staffPct}%`,
      hint: staffTotal === 0
        ? 'Not marked yet'
        : `${staffPresent} of ${staffTotal} expected`,
      icon: <CalendarOutlined />,
      tone: 'info',
    },
    {
      key: 'on-leave',
      label: 'On leave today',
      value: data.staffAttendanceToday.onLeave,
      hint: 'Approved leave for today',
      icon: <ScheduleOutlined />,
      tone: 'warning',
    },
  ];

  return (
    <div style={{ display: 'grid', gap: 20 }}>
      <DashboardHeader role={data.role} asOf={data.asOf} title="HR overview" />
      <KpiGrid kpis={kpis} />

      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <Card title="People ops" size="small">
            <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 2 }}>
              <li><Link to="/hr/staff"><IdcardOutlined /> Staff directory</Link></li>
              <li><Link to="/hr/leave">Leave requests</Link></li>
              <li><Link to="/hr/attendance">Staff attendance</Link></li>
              <li><Link to="/hr/payroll">Payroll runs</Link></li>
              <li><Link to="/hr/salary-advances">Salary advances</Link></li>
            </ul>
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card title="Reports" size="small">
            <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 2 }}>
              <li><Link to="/reports/payroll-register">Payroll register</Link></li>
              <li><Link to="/hr/evaluations">Performance evaluations</Link></li>
            </ul>
          </Card>
        </Col>
      </Row>

      <RecentNoticesCard notices={data.recentNotices} />
    </div>
  );
}
